import { createSlice } from "@reduxjs/toolkit";
import { ANALYTICS_SMALL_VIEW_SUBMIT } from "./constants";
import {
  bufferRefinementEvent,
  clearBufferedRefinementEvent,
} from "./actions/refinementEvents";

const analyticsSlice = createSlice({
  name: "analytics",
  initialState: { pendingAnalytics: {} },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(bufferRefinementEvent, (state, action) => {
        const { refinementPendingActionType, refinementPendingPayload } =
          action.payload;

        // Pressing Done submits the refinements the shopper has been ticking,
        // so it rides alongside whatever is already buffered rather than
        // replacing it. Everything else is the latest intent, and wins.
        if (
          refinementPendingActionType === ANALYTICS_SMALL_VIEW_SUBMIT &&
          state.pendingAnalytics.refinementPendingActionType
        ) {
          state.pendingAnalytics.smallViewSubmitPayload =
            refinementPendingPayload;

          return;
        }

        state.pendingAnalytics = action.payload;
      })
      .addCase(clearBufferedRefinementEvent, (state) => {
        state.pendingAnalytics = {};
      });
  },
});

export default analyticsSlice.reducer;
